import { defineMessages } from 'react-intl.macro';

import React from 'react';

import { useMessage } from '@tmapy/intl';
import { CtaLink, BtnBar } from '@tmapy/style-guide';

import { APP_TYPE } from '../../constants';
import { useSelector } from '../../hooks';

const appTitleMessages = defineMessages<APP_TYPE>({
  [APP_TYPE.PREJIMKA]: {
    id: 'prejimka.title',
    defaultMessage: 'Přejímka',
  },
  [APP_TYPE.MANAGER]: {
    id: 'manager.title',
    defaultMessage: 'Manažer',
  },
  [APP_TYPE.VYDEJ]: {
    id: 'vydej.title',
    defaultMessage: '{customerType, select, ipr {eVýdej} other {Výdej}}',
  },
});

const isAppType = (application: string): application is APP_TYPE =>
  Object.values<string>(APP_TYPE).includes(application);

export const RelatedApps: React.FC<{ allowedApps: [string, string][] }> = ({ allowedApps }) => {
  const formatMessage = useMessage();
  const customerType = useSelector((state) => state.app.config.customerType);

  return (
    <BtnBar stretch>
      {allowedApps.map(([application, appUrl]) => (
        <CtaLink key={application} href={appUrl}>
          {isAppType(application)
            ? formatMessage(appTitleMessages[application], { customerType })
            : application}
        </CtaLink>
      ))}
    </BtnBar>
  );
};
